import { sendCommand } from './command.js';
import { safeJSONParse } from '../utils/safeJSONParse.js';
import { log, error } from '../utils/logger.js';

var AsyncResponseStatuses;
(function (AsyncResponseStatuses) {
    AsyncResponseStatuses[AsyncResponseStatuses["SUCCESS"] = 0] = "SUCCESS";
    AsyncResponseStatuses[AsyncResponseStatuses["ERROR"] = 1] = "ERROR";
    AsyncResponseStatuses[AsyncResponseStatuses["CANCELLED"] = 2] = "CANCELLED";
})(AsyncResponseStatuses || (AsyncResponseStatuses = {}));
if (!window.webAsyncRequests) {
    window.webAsyncRequests = {};
}
function sendAsyncAction(asyncParams) {
    let params = Object.assign({}, asyncParams);
    if (!params.callbackRequestId) {
        params.callbackRequestId = `${params.actionId}_${Date.now()}_${Math.random()}`;
    }
    if (window.webAsyncRequests[params.callbackRequestId]) {
        error('Callback already exists', params.callbackRequestId, Object.keys(window.webAsyncRequests));
        throw new Error('Callback already exists');
    }
    return new Promise((resolver, rejecter) => {
        window.webAsyncRequests[params.callbackRequestId] = {
            resolver,
            rejecter,
        };
        log('Calling async action', params);
        sendCommand({
            command: 'action',
            params,
        });
    });
}
function webAsyncJsHostActionsResponseCallback({ status, callbackRequestId, data }) {
    if (!callbackRequestId) {
        error('Param callbackRequestId was not provided by client', status, data);
        throw new Error('Param callbackRequestId was not provided by client');
    }
    if (!window.webAsyncRequests[callbackRequestId]) {
        error('callbackRequestId not registered at webAsyncRequests', window.webAsyncRequests);
        throw new Error('callbackRequestId not registered at webAsyncRequests');
    }
    switch (status) {
        case AsyncResponseStatuses.SUCCESS: {
            window.webAsyncRequests[callbackRequestId].resolver({
                status,
                data,
            });
            break;
        }
        case AsyncResponseStatuses.ERROR:
        case AsyncResponseStatuses.CANCELLED:
        default: {
            window.webAsyncRequests[callbackRequestId].rejecter({
                status,
                data: null,
            });
            break;
        }
    }
    delete window.webAsyncRequests[callbackRequestId];
}
if (!window.webJsHostActionsListeners) {
    window.webJsHostActionsListeners = [];
}
window.webJsHostActionsListeners.push(webAsyncJsHostActionsResponseCallback);
if (!window.jsHostActionsResponseCallback) {
    window.jsHostActionsResponseCallback = (text) => {
        const response = safeJSONParse(text);
        log('Push data to all async callbacks', Object.keys(window.webJsHostActionsListeners).length, response);
        window.webJsHostActionsListeners.forEach((listener) => {
            listener(response);
        });
    };
}

export { AsyncResponseStatuses, sendAsyncAction };
//# sourceMappingURL=async.js.map
